import { webAPI } from '../../../axiosInstance';


const getAllProducts = async (productDetails: any) => {
  const response = await webAPI.get('/products/profile/admin', {
    params: {
      start_page: productDetails.pages.startPage,
      limit: productDetails.pages.itemsperpage,
    },
  });
  return response.data;
};

const getCatogories = async (categoryDetails: any) => {
  const response = await webAPI.get("/categories");
  // console.log("response", response);

  return response.data;
};

const getBrands = async (categoryDetails: any) => {
  const response = await webAPI.get("/brands");
  // console.log("responsebrands", response);

  return response.data;
};

const getTags = async (details: any) => {
  const response = await webAPI.get("/tags");
  // console.log("response2", response);

  return response.data;
};

const addProduct = async (data: any) => {
  const response = await webAPI.post('/products', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const deleteProduct = async (data: any) => {
  const response = await webAPI.delete(`/products/delete/${data}`);
  return response.data;
};

export { getAllProducts, addProduct, getCatogories, getBrands, getTags, deleteProduct };
